import { render } from "./App.vue?vue&type=template&id=c441f582"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c441f582&lang=scss"

import exportComponent from "/Users/jissjohnson/code/Bitwissend/gnaw-now-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__